import { ClientsScreen } from "../screens/admin/clients.screen";
import { ContactUsDetailScreen } from "../screens/admin/contact_us_detail.screen";
import { CreateClientScreen } from "../screens/admin/create_client.screen";
import { CreateDriverScreen } from "../screens/admin/create_driver.screen";
import { AdminGraphScreen } from "../screens/admin/graph.screen";
import { InfringementsScreen } from "../screens/admin/infringements.screen";
import { MessageCenterScreen } from "../screens/admin/message_center.screen";
import { DriversScreen } from "../screens/admin/drivers.screen";
import { MessagesScreen } from "../screens/client/messages.screen";
import { NewOrderScreen } from "../screens/common/new_order.screen";
import { TrackOrderScreen } from "../screens/common/track.screen";
import { AccidentScreen } from "../screens/common/accidents.screen";
import { ActiveTripsScreen } from "../screens/admin/active_trip_orders.screen";
import { CreateAccidentReport } from "../screens/admin/create_accident_report.screen";
import { RegionalManagersScreen } from "../screens/admin/regional_managers.screen";
import { isAdminRole, isRegionalManagerRole } from "../constants/general.constant";

const NoAdminAccessScreen = () => (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
        <h1 className="text-2xl font-semibold text-[#221b16]">CMS access unavailable</h1>
        <p className="mt-3 max-w-xl text-[#6e6258]">
            This account is not set up as an admin or regional manager.
        </p>
    </div>
);

const ADMIN_NAVIGATOR = [
    {
        parent: "General"
    },
    {
        name: "Messages",
        link: "message-center",
        page: <MessageCenterScreen />
    },
    {
        name: "Contact Us Details",
        link: "contact-us-details/:id",
        page: <ContactUsDetailScreen />,
        noSidebar: true
    },
    {
        name: "Messages",
        link: '',
        page: <MessageCenterScreen />,
        noSidebar: true,
    },
    {
        name: "Messages",
        link: 'messages',
        page: <MessagesScreen />,
        noSidebar: true,
    },
    {
        parent: "Regional Managers"
    },
    {
        name: "Regional Managers",
        link: "regional-managers",
        page: <RegionalManagersScreen />
    },

    {
        parent: "Clients"
    },
    {
        name: "All Clients",
        link: "clients",
        page: <ClientsScreen />
    }, {
        name: "Create Client",
        link: "create-client",
        page: <CreateClientScreen key="create" />
    },
    {
        name: "Create Client",
        link: "create-client/:id",
        noSidebar: true,
        page: <CreateClientScreen key="update" />
    },
    {
        parent: "Purchase Orders"
    },
    {
        name: "New Trip Order",
        link: "new-trip-order",
        page: <NewOrderScreen />
    },
    {
        name: "Active Trip Orders",
        link: "active-trip-orders",
        page: <ActiveTripsScreen key="active" />
    },
    {
        name: "Trip Order History",
        link: "trip-order-history",
        page: <ActiveTripsScreen key="history" history />
    },
    {
        parent: "Drivers"
    },
    {
        name: "Driver List",
        link: "drivers",
        page: <DriversScreen />
    },
    {
        name: "Create Driver",
        link: "create-driver",
        page: <CreateDriverScreen key="create" />
    },

    {
        name: "Create Driver",
        link: "create-driver/:id",
        page: <CreateDriverScreen key="update" />,
        noSidebar: true

    },
    {
        parent: "Vehicles"
    },
    {
        name: "Live Infringements",
        link: "infringements",
        page: <InfringementsScreen />
    },
    {
        name: "Navigation",
        link: "track",
        page: <TrackOrderScreen />
    },
    {
        name: "Accident Details",
        link: "accident-details/:id",
        page: <CreateAccidentReport />,
        noSidebar: true
    },
    {
        name: "Create Accident",
        link: "create-accident-report",
        page: <CreateAccidentReport />,
        noSidebar: true
    },
    {
        name: "Accident Reports",
        link: "accident-reports",
        page: <AccidentScreen admin />
    },
    {
        name: "Analytics",
        link: "analytics",
        page: <AdminGraphScreen />
    },
    {
        noSidebar: true,
        name: "Messages",
        link: "sign-in",
        page: <MessageCenterScreen />
    },

];

export const AdminNavigator = (user = {}) => {
    if (isAdminRole(user)) return ADMIN_NAVIGATOR;
    if (!isRegionalManagerRole(user)) {
        return [
            {
                name: "CMS access unavailable",
                link: "",
                page: <NoAdminAccessScreen />,
                noSidebar: true
            }
        ];
    }

    return [
        {
            name: "Active Trip Orders",
            link: "",
            page: <ActiveTripsScreen key="regional-active-home" />,
            noSidebar: true
        },
        {
            parent: "Purchase Orders"
        },
        {
            name: "New Trip Order",
            link: "new-trip-order",
            page: <NewOrderScreen />
        },
        {
            name: "Active Trip Orders",
            link: "active-trip-orders",
            page: <ActiveTripsScreen key="regional-active" />
        },
        {
            name: "Trip Order History",
            link: "trip-order-history",
            page: <ActiveTripsScreen key="regional-history" history />
        },
        {
            parent: "Drivers"
        },
        {
            name: "Driver List",
            link: "drivers",
            page: <DriversScreen />
        },
        {
            parent: "Vehicles"
        },
        {
            name: "Live Infringements",
            link: "infringements",
            page: <InfringementsScreen />
        },
        {
            name: "Navigation",
            link: "track",
            page: <TrackOrderScreen />
        },
    ];
}
